'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Panel = require('components/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

var _PlayStatsChart = require('components/Statistics/PlayStatsChart/PlayStatsChart');

var _PlayStatsChart2 = _interopRequireDefault(_PlayStatsChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./TrackDetailsStatistics.scss');

var TrackDetailsStatistics = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(TrackDetailsStatistics, _PureComponent);

  function TrackDetailsStatistics() {
    (0, _classCallCheck3.default)(this, TrackDetailsStatistics);
    return (0, _possibleConstructorReturn3.default)(this, (TrackDetailsStatistics.__proto__ || (0, _getPrototypeOf2.default)(TrackDetailsStatistics)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrackDetailsStatistics, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          _props$data = _props.data,
          fullName = _props$data.fullName,
          stats = _props$data.stats,
          trackId = _props$data.trackId;


      return _react2.default.createElement(
        _Panel2.default,
        {
          className: (0, _bind2.default)(styles.panel, className),
          title: fullName
        },
        _react2.default.createElement(_PlayStatsChart2.default, { data: stats, id: 'trackDetails' + trackId })
      );
    }
  }]);
  return TrackDetailsStatistics;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  data: _propTypes2.default.object
}, _class.defaultProps = {
  data: { stats: [] }
}, _temp);
exports.default = TrackDetailsStatistics;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/TrackDetailsStatistics/TrackDetailsStatistics.js
// module id = 2129
// module chunks = 1